import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { ItemDirection } from "@domain/ItemDirection";
import { RouteTravelMode } from "@lib/maps/@google/types";
import { convertLegacyTravelMode } from "@lib/maps/convertLegacyTravelMode";

interface RouteState {
  directions: ItemDirection[] | null;
  travelMode: RouteTravelMode;
  navigationDirectionIndex: number;
}

const initialState: RouteState = {
  directions: null,
  travelMode: convertLegacyTravelMode(VisitWidget.settings.mapTravelMode),
  navigationDirectionIndex: 0,
};

export const planRouteSlice = createSlice({
  name: "planRoute",
  initialState,
  reducers: {
    setDirections: (state, action: PayloadAction<ItemDirection[]>) => {
      state.directions = action.payload;
    },
    setTravelMode: (state, action: PayloadAction<RouteTravelMode>) => {
      state.travelMode = action.payload;
    },
    setNavigationDirectionIndex: (state, action: PayloadAction<number>) => {
      state.navigationDirectionIndex = action.payload;
    },
  },
});

export const selectDirections = (state: RootState) => {
  return state.planRoute.directions;
};

export const selectTravelMode = (state: RootState) => {
  return state.planRoute.travelMode;
};

export const selectNavigationDirectionIndex = (state: RootState) => {
  return state.planRoute.navigationDirectionIndex;
};

export const { setDirections, setTravelMode, setNavigationDirectionIndex } =
  planRouteSlice.actions;

// eslint-disable-next-line import/no-default-export
export default planRouteSlice.reducer;
